export default __webpack_public_path__ + "static/media/new_message.c93a1a9c.mp3";